module.exports = __webpack_public_path__ + "03_face.b978440f.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/boy/layer1/03_face.png
// module id = 031c
// module chunks = 0